module.exports = __webpack_public_path__ + "static/img/viewicons.fa08254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viewicons.png
// module id = BqUs
// module chunks = 1